import { useState, useId } from 'react';
import { Modal, ModalFooter, ModalBody, ModalHeader } from 'ui/modal';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { Body2 } from 'ui/theme';
import type { DemoDataDeleteModalProps } from '../types';

export const DELETE_DEMO_DATA_TEST_ID = 'delete-demo-data-modal';
export const DELETE_BUTTON_TEST_ID = 'delete-demo-data-modal-delete-button';
export const DELETE_DEMO_DATA_INPUT_ID = 'delete-demo-data-modal-delete-input';

export const DemoDataDeleteModal = ({ onClose, onDelete }: DemoDataDeleteModalProps) => {
  const [confirmText, setConfirmText] = useState('');
  const formFieldId = useId();
  const modalId = useId();

  const handleSubmit = () => {
    onDelete(confirmText);
  };

  return (
    <Modal
      data-test={DELETE_DEMO_DATA_TEST_ID}
      id={modalId}
      isModalOpen
      onClose={onClose}
      size="small"
    >
      <ModalHeader>Delete demo data?</ModalHeader>
      <ModalBody>
        <Body2>This will delete ALL DATA in the existing project.</Body2>
        <Body2>To proceed, please type the project name in again:</Body2>
        <FormField inputId={formFieldId}>
          <InputText
            data-test={DELETE_DEMO_DATA_INPUT_ID}
            id={formFieldId}
            onChange={(newVal) => setConfirmText(newVal)}
            value={confirmText}
          />
        </FormField>
      </ModalBody>
      <ModalFooter>
        <PrimaryButton
          size={BUTTON_SIZES.LARGE}
          data-test={DELETE_BUTTON_TEST_ID}
          onClick={handleSubmit}
        >
          Delete demo data
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
